import { apiSlice } from '../../app/apiSlice';
import configUrlSetor from '../../config/urls/configUrlSetor';
import { useSetorRoutes } from '../../config/useSetorRoutes';
import { Setor } from '../../types/setor/Setor';

const endpointUrl = configUrlSetor.SETOR_API_EP;

function createSetor(obj: Setor) {
  return {
    url: `${endpointUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function updateSetor(obj: Setor) {
  return {
    url: `${endpointUrl}/${obj.id}`,
    method: 'PUT',
    body: obj
  };
}

function deleteSetor({ id }: { id: string }) {
  return {
    url: `${endpointUrl}/${id}`,
    method: 'DELETE'
  };
}
function getSetores(search: string) {
  return {
    url: `${endpointUrl}/filter?search=${search}`,
    method: 'GET'
  };
}

export const setorApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getSetor: query<Setor, string>({
      query: id => `${endpointUrl}/${id}`,
      providesTags: ['Setor']
    }),

    getSetores: query<Setor[], string>({
      query: getSetores,
      providesTags: ['Setor']
    }),

    createSetor1: mutation<Setor, Setor>({
      query: createSetor,
      invalidatesTags: ['Setor']
    }),

    createSetor: mutation<Setor, Setor>({
      query: obj => ({
        url: `${endpointUrl}/create`, // Usando a variável endpointUrl diretamente
        method: 'POST', // Método POST para criar o setor
        body: obj // Corpo da requisição com os dados do novo setor
      }),
      invalidatesTags: ['Setor']
    }),

    updateSetor: mutation<Setor, Setor>({
      query: updateSetor,
      invalidatesTags: ['Setor']
    }),

    deleteSetor: mutation<Setor, { id: string }>({
      query: deleteSetor,
      invalidatesTags: ['Setor']
    })
  })
});
export const { useGetSetorQuery, useGetSetoresQuery, useCreateSetorMutation, useUpdateSetorMutation, useDeleteSetorMutation, useCreateSetor1Mutation } = setorApiSlice;
